import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrivaNotificationComponent } from '@priva/components/notification';
import { PrivaTitleComponent } from '@priva/components/title';
import { PrivaLocalizationModule } from '@priva/localization';

import { setActivityInScanFlow } from 'app/features/scan-flow/state/scan-flow/scan-flow.actions';
import {
    createScannedCodeFromActivity,
    createScannedCodeFromTimeRegistrationActivity,
} from 'app/features/scan-flow/state/scanned-codes/utils/scanned-code.utils';
import { isSystemActivityCodeValid } from 'app/features/scan-flow/utils';
import { GroupTilesPipe } from 'app/shared/components/tile-list/group-tiles.pipe';
import { Tile, TileDivider } from 'app/shared/components/tile-list/models';
import { TileListUtils } from 'app/shared/components/tile-list/tile-list.utils';
import { TileComponent } from 'app/shared/components/tile-list/tile/tile.component';
import { isSupportedBreakActivity } from 'app/shared/features/activity-selector/utils';
import { activatingBreakDialog, breakStarting } from 'app/state/break/break.actions';

import { createTimeRegistrationActivity } from './models/time-registration-definition';
import { SystemAndBreakActivityStore } from './system-and-break-activity.store';

@Component({
    selector: 'app-system-and-break-activity',
    imports: [
        PrivaLocalizationModule,
        PrivaNotificationComponent,
        PrivaTitleComponent,
        TileComponent,
        GroupTilesPipe,
    ],
    providers: [SystemAndBreakActivityStore],
    templateUrl: './system-and-break-activity.component.html',
    styleUrl: './system-and-break-activity.component.scss',
})
export class SystemAndBreakActivityComponent {
    private store = inject(Store);
    systemAndBreakActivityStore = inject(SystemAndBreakActivityStore);
    protected readonly tileListUtils = TileListUtils;

    constructor() {
        /** Dispatching activatingBreakDialog action to ensure that the break dialog is closed when navigating to other component
         * This is necessary because the system and break activity component can be navigated to from the break dialog
         * We want to ensure that the break dialog is closed when navigating to the component
         */
        this.store.dispatch(activatingBreakDialog());
    }

    onTileClick(tile: Tile) {
        let activity;
        let activityCode;
        if (isSystemActivityCodeValid(tile.id)) {
            activity = createTimeRegistrationActivity(tile.id);
            activityCode = createScannedCodeFromTimeRegistrationActivity(activity);
        } else {
            activity = this.systemAndBreakActivityStore.getEndBreakActivity(tile.id);
            activityCode = activity ? createScannedCodeFromActivity(activity) : undefined;
        }
        if (
            this.systemAndBreakActivityStore.appMode() === 'multi-user' ||
            (this.systemAndBreakActivityStore.appMode() === 'personal' &&
                activity &&
                !isSupportedBreakActivity(activity))
        ) {
            this.store.dispatch(setActivityInScanFlow({ activityCode, keepRegistrationData: true }));
        } else if (activity) {
            this.store.dispatch(breakStarting({ activity }));
        }
    }

    protected isDividerTile(tile: Tile | TileDivider): tile is TileDivider {
        return Boolean(tile?.dividerText);
    }
}
